module.exports = __webpack_public_path__ + "img/ickey_logo.563bcd4d.png";